var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isRoutable
    ? _c(
        _vm.linkTag,
        _vm._b(
          {
            tag: "component",
            attrs: { custom: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({
                    href,
                    route,
                    navigate,
                    isActive,
                    isExactActive,
                  }) {
                    return [
                      _c(
                        "li",
                        {
                          class: [
                            _vm.$style["mds-tabs__item"],
                            _vm.classObject,
                            _vm.activeClass(isActive, isExactActive),
                          ],
                          attrs: { role: "tab" },
                          on: { click: _vm.makeActive },
                        },
                        [
                          _c(
                            "mds-button",
                            {
                              attrs: {
                                href: href,
                                "on-dark": _vm.onDark,
                                icon: _vm.icon,
                                "icon-right": _vm.iconRight,
                                size: _vm.size,
                                text: _vm.text,
                                variation: "flat",
                                type: _vm.typeAttribute,
                                target: _vm.target,
                              },
                              on: { click: navigate },
                            },
                            [
                              _vm._t("default", function () {
                                return [_vm._v(_vm._s(_vm.text))]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          "component",
          _vm.routingProps,
          false
        )
      )
    : _c(
        "li",
        {
          class: [_vm.$style["mds-tabs__item"], _vm.classObject],
          attrs: { role: "tab" },
          on: { click: _vm.makeActive },
        },
        [
          _c(
            "mds-button",
            {
              attrs: {
                href: _vm.href,
                "on-dark": _vm.onDark,
                icon: _vm.icon,
                "icon-right": _vm.iconRight,
                size: _vm.size,
                text: _vm.text,
                variation: "flat",
                type: _vm.typeAttribute,
                disabled: _vm.disabledAttribute,
                target: _vm.target,
              },
            },
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              }),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }